import React, { useCallback, useMemo } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { childrenSelectWarning, maxFlightInfantAge, maxFlightChildAge, maxFlightPassengerCount, maxInfantsWarning } from 'constants/flight'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { validateOccupants } from 'lib/flights'

import WarningMessage from './WarningMessage'
import OccupancyItem from 'components/Common/OccupancyPicker/OccupancyItem'

const Root = styled.div`
  display: flex;
  flex-direction: column;
`

const Warning = styled(WarningMessage)`
  margin: 0 ${rem(16)} ${rem(16)};

  ${mediaQueryUp.sm} {
    margin: 0 ${rem(24)} ${rem(24)};
  }
`

const StyledOccupancyItem = styled(OccupancyItem)`
  border: none;
  box-shadow: none;
  border-radius: ${props => props.theme.borderRadius.medium};

  > div {
    border: none;
    box-shadow: none;
    border-radius: ${props => props.theme.borderRadius.medium};
  }
`

interface Props {
  occupants: App.Occupants;
  setOccupants: (value: App.Occupants) => void;
}

const TravellerDropdown = (props: Props) => {
  const { occupants, setOccupants } = props

  const onChangeOccupants = useCallback((itemId: number, nextOccupancy: App.Occupants) => {
    setOccupants(nextOccupancy)
  }, [setOccupants])

  const isInfantsAdded = occupants.childrenAge.some((age) => age !== -1 && age <= maxFlightInfantAge)

  const capacity = useMemo(() => ({
    adults: maxFlightPassengerCount - occupants.childrenAge.length,
    children: maxFlightPassengerCount - occupants.adults,
    infants: maxFlightPassengerCount - occupants.adults,
  }), [occupants])

  const invalidSelection = useMemo(() => validateOccupants(occupants), [occupants])

  return (
    <Root>
      <StyledOccupancyItem
        itemId={0}
        occupancy={occupants}
        onChange={onChangeOccupants}
        maxChildAge={maxFlightChildAge}
        maxInfantAge={maxFlightInfantAge}
        childrenAgeLabel="at time of return flight"
        capacities={[capacity]}
      />
      {isInfantsAdded && !invalidSelection && <Warning message={childrenSelectWarning} />}
      {invalidSelection && <Warning message={maxInfantsWarning} />}
    </Root>
  )
}

export default TravellerDropdown
